/** Emails that should never be treated as coaching clients. */
export const ADMIN_EMAILS = [
  'hello@fitbycassie.com',
]
export function isAdminEmail(email?: string | null): boolean {
  if (!email) return false
  return ADMIN_EMAILS.includes(email.trim().toLowerCase())
}
